import { useTranslation } from "react-i18next";
import heroImage from "@/assets/onboarding-welcome-hero.webp";

export function OnboardingSlideZero() {
  const { t } = useTranslation();

  return (
    <div className="h-full flex flex-col items-center px-6 pt-20 pb-48 relative overflow-hidden">
      {/* Hero image - positioned at top with padding, fixed dimensions to prevent CLS */}
      <img
        src={heroImage}
        alt="Axis Money"
        width={384}
        height={512}
        className="w-96 h-auto max-w-full"
        loading="eager"
      />

      {/* Text content with glass card - minimal gap */}
      <div 
        className="text-center relative z-10 px-6 py-5 rounded-2xl w-full max-w-xs mt-4"
        style={{
          background: 'linear-gradient(135deg, hsl(var(--card) / 0.6), hsl(var(--card) / 0.3))',
          backdropFilter: 'blur(20px) saturate(180%)',
          border: '1px solid hsl(var(--border) / 0.3)',
        }}
      >
        <h1 className="text-2xl font-bold text-foreground mb-3 leading-snug">
          {t("onboarding.zero.title")}
        </h1>
        <p className="text-muted-foreground text-base leading-relaxed">
          {t("onboarding.zero.description")}
        </p>
      </div>
    </div>
  );
}
